import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { HouseSelect } from "@/components/expenses/HouseSelect";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/AuthProvider";
import { useQuery } from "@tanstack/react-query";

export const JoinHouseDialog = () => {
  const [open, setOpen] = useState(false);
  const [selectedHouse, setSelectedHouse] = useState("");
  const { toast } = useToast();
  const { user } = useAuth();

  // Fetch available houses
  const { data: houses = [] } = useQuery({
    queryKey: ['available-houses'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('houses')
        .select('id, name');

      if (error) {
        console.error('Error fetching houses:', error);
        toast({
          title: "Error",
          description: "No se pudieron cargar las casas disponibles",
          variant: "destructive",
        });
        return [];
      }

      return data;
    },
  });

  const handleJoinHouse = async () => {
    if (!selectedHouse || !user) return;

    const { error } = await supabase
      .from('house_members')
      .insert({
        house_id: selectedHouse,
        user_id: user.id,
        role: 'tenant'
      });

    if (error) {
      console.error('Error joining house:', error);
      toast({
        title: "Error",
        description: "No se pudo unir a la casa",
        variant: "destructive",
      });
      return;
    }

    toast({
      title: "¡Éxito!",
      description: "Te has unido a la casa exitosamente",
    });
    setOpen(false);
    window.location.reload(); // Refresh to update the UI
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>Unirse a una casa</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Unirse a una casa</DialogTitle>
          <DialogDescription>
            Selecciona la casa a la que deseas unirte
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <HouseSelect
            houses={houses}
            value={selectedHouse}
            onValueChange={setSelectedHouse}
          />
          <Button onClick={handleJoinHouse} disabled={!selectedHouse}>
            Confirmar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};